import api from "./apiWithAccessToken";

export const getIngestionJob = (jobId) =>
  api.get(`/ingestion-jobs/${jobId}`);

export const listIngestionJobs = (sourceDbId, active = true) =>
  api.get("/ingestion-jobs", {
    params: {
      ...(sourceDbId === null || sourceDbId === undefined || sourceDbId === ""
        ? {}
        : { source_db_id: sourceDbId }),
      active,
    },
  });

export const retryIngestionJob = (jobId) =>
  api.post(`/ingestion-jobs/${jobId}/retry`);
